import { MAPBOX_ACCESS_TOKEN } from "./mapboxAccessToken";

interface GeocodeResult {
  longitude: number;
  latitude: number;
}

export async function geocodeCity(
  city: string,
  stateOrProvinceCode: string,
  postalCode: string,
): Promise<GeocodeResult | undefined> {
  const query = `${city}, ${stateOrProvinceCode}, ${postalCode}`;
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${MAPBOX_ACCESS_TOKEN}&limit=1`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      return undefined;
    }

    const data = await response.json();
    const feature = data.features?.[0];
    if (!feature?.center) {
      return undefined;
    }

    const [longitude, latitude] = feature.center;
    return { longitude, latitude };
  } catch {
    return undefined;
  }
}
